export const VEHICLE_STATUS_LABELS = {
	1: "Disponível", // Available
	2: "Manutenção", // InMaintenance
	3: "Inativo", // Inactive
} as const;
